import React, { useEffect, useState } from 'react'
import { useStateValue } from "../../../../context/store";
import Table from './table';
import TablePagination from '@mui/material/TablePagination';
import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';
import SearchAplicationQuestionary from './search';
import ModalConfirm from "../../../../utils/form/modalConfirmBase";
import {getfilterEvaluatedsApplication} from '../../../../actions/ManagementAplicationEvaluations-actions';
import { getRegionals, getPositions} from '../../../../actions/OrganizationChart-action';
import { PATH_APP } from '../../../../constants';


const Index = (props) => {

  const idApplication = props?.match?.params
  const  {applicationId} = idApplication;

  const [{ aplicationQuestionary, loadingTables, evaluatedsSearch }, dispatch] = useStateValue();
  const [clearFielForm, setClearFielForm]= useState(false)
  const [allRegionals, setAllRegionals] = useState([]);
  const [allPositions, setAllPositions] = useState([]);
  const [data, ] = useState({
    regionalName : null,
    positionName: null,
  })
  const [paginadorResponse, setPaginadorResponse] = useState({
    data: [],
    totalRows: 0,
    pageSize: 0,
    pageNumber: 0,
  });
  const [paginadorRequest, setPaginadorRequest] = useState({
    page: 0,
    size: 10,
  });
  
  const [message, setMessage] = useState({
    description : '',
    textButtonSubmit : '',
    textButtonCancel: '',
    handleClick : () => {} ,
    handleClickOut : () => {},
    oneButtons : false,
    buttonsTwo: false,
    title: '',
    type : '',
    open : false
    })

    const closeModalAndClear = () => {
      setClearFielForm(!clearFielForm)
      
    }


    useEffect(()=> {
      window.scrollTo(0,0)
      getAllevaluatedsAplication()
    },[])


  useEffect(() => {
    dispatch({
      type: "SET_BREADCRUMB",
      breadCrumbText: "Autoevaluaciones",
      breadCrumbSubText: "Evaluados",
      index: 13,
      module: 'DETAIL_APLICATION_EVALUATION',
      idForm: 'page',
      subPath: `${PATH_APP}/management-aplication-evaluations`,
    });
    if(paginadorResponse?.data?.length){
    getAllevaluatedsAplication()
  }
  window.scrollTo(0,0)
  }, [paginadorRequest])

  useEffect(()=> {
      
    getRegional();
    getPosition();
    window.scrollTo(0,0)
  },[])

  const closeModal = () => {
    setMessage({...message, open: false}); 
    closeModalAndClear();
}



  const getAllevaluatedsAplication = async() => {

    dispatch({
      type: "EVALUATEDS_APPLICATION_SEARCH",
      filter: {
          regionalName: data?.regionalName,
          positionName: data?.positionName,
          page: paginadorRequest?.page,
          size: paginadorRequest?.size
        },
        isFilter: false,
    })

    const result = await getfilterEvaluatedsApplication(applicationId,{
      programId : data.regionalName === null ? null : data?.regionalName,
      positionName: data.positionName === null ? null : data?.positionName,
      page: paginadorRequest?.page === null ? null : paginadorRequest?.page,
      size:  paginadorRequest?.size === null ? null : paginadorRequest?.size,
        
    }, dispatch);
    
    if(result?.data?.length < 1 && !aplicationQuestionary?.typeAction){
      setPaginadorResponse({
        data: [],
        totalRows: 0,
        pageSize: 0,
        pageNumber: 0,
      });
      return setMessage({
        open : true,
        description: 'No se encontró información relacionada a la búsqueda',
        handleClick : () => closeModal() ,
        oneButtons : true,
        textButtonSubmit: 'ACEPTAR',
        type : 'WARNING',
      })
     }
     if((result?.status > 399) && (result?.status < 405)  ){
      setMessage({
        open : true,
        description: 'No se encontró información relacionada a la búsqueda',
        handleClick : () => closeModal() ,
        oneButtons : true,
        textButtonSubmit: 'ACEPTAR',
        type : 'WARNING',
      })
    }
    if((result?.status > 399) && (result?.status >= 500)  ){
      setMessage({
        open : true,
        description: 'Occurió un problema comuniquese con el administrador.',
        handleClick : () => closeModal() ,
        oneButtons : true,
        textButtonSubmit: 'ACEPTAR',
        type : 'WARNING',
      })
    }
    if (result && (result.status === 200 || result.status === 201)) {
      const data = result?.data;
      if (data?.content?.length > 0) {
        setPaginadorResponse({
          data: data?.content,
          totalRows: data?.totalElements,
          pageSize: data?.size,
          pageNumber: data?.number,
        });
      }
      
    } 
    else {
      setPaginadorResponse({
        data: [],
        totalRows: 0,
        pageSize: 0,
        pageNumber: 0,
      });
    }
  
  
  }

  if(evaluatedsSearch &&
    evaluatedsSearch?.isFilter) {

      const newData = evaluatedsSearch?.filter
      data.regionalName = newData?.regionalName;
      data.positionName = newData?.positionName;
      paginadorRequest.page = newData?.page;
      paginadorRequest.size = newData?.size
      getAllevaluatedsAplication( )
      dispatch({
        type: "EVALUATEDS_APPLICATION_SEARCH",
        filter: evaluatedsSearch?.filter,
        isFilter: false,
      })
     
  }


  const changePage = (event, nuevaPagina) => {
   
    setPaginadorRequest({
      ...paginadorRequest,
      page: nuevaPagina,
  
     
    });
  };

  const changeAmountOfRecords = (event, siguiente) => {
    setPaginadorRequest({
      ...paginadorRequest,
      size: event.target.value,
      page: 0
    });
  };

  const clearFilter = () => {
    dispatch({
      type: "EVALUATEDS_APPLICATION_SEARCH",
      filter: {
          regionalName: null,
          positionName: null,
          page: 0,
          size: 10
        },
        isFilter: true,
  })
    // getAllevaluatedsAplication()
  }

  const getRegional = async() => {
    const result = await getRegionals();  
    setAllRegionals(result?.data?.length ? result?.data : [] )
  }

  const getPosition = async() => {
    const result = await getPositions();  
    setAllPositions(result?.data?.length ? result?.data : [] )
  }


    return (
        <div >
            < SearchAplicationQuestionary 
              message={message}
              setMessage={setMessage}
              regionals={allRegionals}
              positions={allPositions}
              clearFilter={clearFilter}
              clearFielForm={clearFielForm}
            />
            {loadingTables?.active ?
                <Box sx={{ display: 'flex', marginTop:'15%', justifyContent: 'center' }}>
                  <CircularProgress />
                </Box>
                : 
                < Table  
                  data={ paginadorResponse?.data}
                  message={message}
                  setMessage={setMessage}
                />
              
              }
            <ModalConfirm 
              description = { message.description }
              textButtonSubmit = { message.textButtonSubmit }
              textButtonCancel = {message.textButtonCancel}
              handleClick = { message.handleClick }
              handleClickOut = { message.handleClickOut }
              oneButtons = { message.oneButtons }
              title = { message.title }
              type = { message.type }
              open = { message.open }
            />
             {paginadorResponse?.totalRows !== 0 && !loadingTables?.active &&
                <TablePagination
                  style={{ marginLeft: "25%", display:"flex", color: '#747578' }}
                  component="div"
                  rowsPerPageOptions={[5, 10, 15]}
                  count={paginadorResponse.totalRows}
                  rowsPerPage={paginadorRequest.size}
                  page={paginadorRequest.page}
                  labelRowsPerPage='Registros por página'
                  onPageChange={changePage}
                  onRowsPerPageChange={(e)=>changeAmountOfRecords(e)}
                />
             }
             
        </div>
    )
}

export default Index

